// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__34a2P","rootSuccess":"CompleteLink_rootSuccess__IjWNg","rootFailure":"CompleteLink_rootFailure__2ETnK","isDisabled":"CompleteLink_isDisabled__3aSWX"};